import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Button, Modal, Typography } from '@mui/material';

import { CONTRACT_TYPES } from '../../../../contracts/constants';

import modalStyles from './ContractTypeSelectModal.styles';

const ContractTypeSelectModal = ({ isOpen, onClose, userId }) => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState(null);

  const handleOptionSelect = (type) => {
    setSelectedType(type);
  };

  const handleNext = () => {
    navigate(`/users/${userId}/${selectedType}/contracts/create`);

    onClose();
  };

  const handleCancel = () => {
    setSelectedType(null);
    onClose();
  };

  const renderOptionCard = (type, titleKey, descriptionKey) => {
    const isSelected = selectedType === type;

    return (
      <Box
        sx={{
          ...modalStyles.optionCard,
          ...(isSelected && modalStyles.selectedOptionCard),
        }}
        onClick={() => handleOptionSelect(type)}
      >
        <Typography sx={modalStyles.optionTitle}>{LanguageConverterV2(titleKey)}</Typography>
        <Typography sx={modalStyles.optionDescription}>
          {LanguageConverterV2(descriptionKey)}
        </Typography>

        <Box sx={modalStyles.selectionIndicator}>
          {isSelected && (
            <Typography sx={modalStyles.selectedText}>
              {LanguageConverterV2('contract.typeSelect.selected')}
            </Typography>
          )}
          <Box
            sx={{
              ...modalStyles.radioButton,
              ...(isSelected && modalStyles.selectedRadioButton),
            }}
          >
            {isSelected && <Box sx={modalStyles.radioInner} />}
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleCancel}
      aria-labelledby="contract-type-modal-title"
      aria-describedby="contract-type-modal-description"
      sx={modalStyles.container}
    >
      <Box sx={modalStyles.modalBox}>
        <Box sx={modalStyles.contentBox}>
          <Box>
            <Typography sx={modalStyles.title}>
              {LanguageConverterV2('contract.typeSelect.title')}
            </Typography>
            <Typography sx={modalStyles.subtitle}>
              {LanguageConverterV2('contract.typeSelect.subtitle')}
            </Typography>
          </Box>

          <Box sx={modalStyles.optionsContainer}>
            {renderOptionCard(
              CONTRACT_TYPES.MARGIN_OVERRIDE,
              'contract.typeSelect.marginOverride.title',
              'contract.typeSelect.marginOverride.description'
            )}

            {renderOptionCard(
              CONTRACT_TYPES.RATE_OVERRIDE,
              'contract.typeSelect.rateOverride.title',
              'contract.typeSelect.rateOverride.description'
            )}
          </Box>

          <Box sx={modalStyles.buttonsContainer}>
            <Button variant="outlined" onClick={handleCancel} sx={modalStyles.cancelButton}>
              {LanguageConverterV2('button.cancel')}
            </Button>
            <Button
              variant="contained"
              onClick={handleNext}
              disabled={!selectedType}
              sx={modalStyles.nextButton}
            >
              {LanguageConverterV2('button.next')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

ContractTypeSelectModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userId: PropTypes.string,
};

export default ContractTypeSelectModal;
